import { defineAsyncComponent } from 'vue'
export default {
  basic: defineAsyncComponent(() => import("/app/layouts/basic.vue")),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue"))
}